import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Campo, Formulario, TipoCampo } from "../../Formulario";
import { useAuth } from "../../../Auth";
import { Button, Card, Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { ChevronLeft, Gear, Save } from "react-bootstrap-icons";
import { fetchApi, filtro_unicos } from "../../../Funciones";
import { TagList, TagSelector } from "../Tags/Manager";
import { EstadosContenido } from "./Home";

export const Edit: React.FC<{ id?: any }> = ({ id }) => {

	const params = useParams()
	let nav = useNavigate();
	let auth = useAuth()

	const [CID, setCID] = useState("")
	const [data, setData] = useState(new FormData());
	const [etiquetas, setEtiquetas] = useState<any[]>([])

	const getData = async (cid: any) => {
		var resp = await fetchApi(auth.user.token, "content", {
			cmd: "get",
			id: cid
		})
		if (resp.estado === "ok") {
			var d = new FormData();
			["title", "content", "publish_date", "state"].forEach(campo => {
				d.set(campo, resp[campo])
			});
			setEtiquetas(resp.tags)
			setData(d)
		}
	}

	useEffect(() => {
		if (auth.user) {
			var cid = ""
			var d = new FormData();

			if (id && id !== "") {
				cid = id
			}
			else {
				if (params.id && params.id !== "") {
					cid = params.id
				}
			}

			if (cid !== "") {
				getData(cid)
			}
			else {
				const ahora = new Date()
				var fecha = ahora.toLocaleDateString("es-CL").split("-").reverse().join("-")
				var hora = ahora.toLocaleTimeString().split(":").splice(0, 2).join(":")
				d.set("publish_date", fecha + " " + hora)
				d.set("state", "draft")
				setData(d)
			}
			setCID(cid)
		}
		// eslint-disable-next-line
	}, [auth.user])

	const submit = async (ev: any) => {
		data.set("cmd", "save")
		data.set("cid", CID)

		var tagIds = etiquetas.reduce((acc: any[], current: any) => { acc.push(current.id); return acc }, []).filter(filtro_unicos)
		data.set("tags", tagIds.join(","))

		let res = await fetchApi(auth.user.token, "content", data)
		if (res.estado === "ok") {
			nav(-1)
		}
		else {
			alert(res.msg)
		}
	}

	const change = (ev: any) => {
		//validaciones
		let d = new FormData()
		data.forEach((val, key) => {
			d.set(key, val)
		})
		if (ev.target.targetElm) { //editor
			d.set(ev.target.targetElm.name, ev.target.getContent())
		}
		else if (ev.target.type !== "file") {
			d.set(ev.target.name, ev.target.value)
		}
		else {
			if (ev.target.files.length > 0)
				d.set(ev.target.name, ev.target.files[0])
			else
				d.delete(ev.target.name)
		}
		setData(d)
	}

	return <>
		<Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>

		<Row>
			<Col xs={12}>
				<Card className="shadow">
					<Card.Header className="bg-dark text-white">{CID !== "" ? "Editar" : "Nuevo"} Contenido</Card.Header>
					<Card.Body>
						<Formulario submit={(ev: any) => submit(ev)} change={(ev: any) => change(ev)} datos={data}>

							<Row>
								<Col xs={7}>
									<FormGroup className="form-floating">
										<Campo tipo={TipoCampo.Texto} nombre="title" required />
										<FormLabel htmlFor="form_title" className="text-primary">Título</FormLabel>
									</FormGroup>
								</Col>
								<Col xs={2}>
									<FormGroup className="form-floating">
										<input type="datetime-local" value={data.get("publish_date") ? data.get("publish_date") + "" : ""} onChange={(ev: any) => { change(ev) }} className="form-control form-control-sm" name="publish_date" />
										<FormLabel className="text-primary">Fecha de Publicación</FormLabel>
									</FormGroup>
								</Col>
								<Col xs={2}>
									<FormGroup className="form-floating">
										<Campo tipo={TipoCampo.Select} nombre="state" required>
											<option value=""></option>
											{Object.keys(EstadosContenido).map((key) => {
												return <option key={key} value={key}>{EstadosContenido[key as keyof typeof EstadosContenido].text + ""}</option>
											})}
										</Campo>
										<FormLabel htmlFor="form_state" className="text-primary">Estado</FormLabel>
									</FormGroup>
								</Col>
								<Col xs={1} className="text-end">
									<div><Button type="submit" variant="dark" ><Save /> Guardar</Button></div>
								</Col>
							</Row>

							<FormGroup className="mt-2 border px-3 pt-1 pb-2">
								<FormLabel className="text-primary mb-0">Etiquetas</FormLabel>
								<div>
									<TagList list={etiquetas} />
									<TagSelector current={etiquetas} onSelect={(tags: any[]) => setEtiquetas(tags)} newButton>
										<Button size="sm" variant="outline-secondary"><Gear /></Button>
									</TagSelector>
								</div>
							</FormGroup>

							<FormGroup className="mt-2 border px-3 pt-1 pb-2">
								<FormLabel className="text-primary">Contenido</FormLabel>
								<Campo tipo={TipoCampo.Editor} nombre="content" required />
							</FormGroup>
						</Formulario>
					</Card.Body>
				</Card>
			</Col>
		</Row>
	</>
}
